import React from "react";

const LoginOrRegister = ({ spektrixDomain }) => {
    const createAccountUrl = "/account/";

    return (
        <>
            <h2 data-split-line className="section__heading">
                Picked for you
            </h2>

            <p className="type-body-xl">
                To see our recommendations picked for you, sign into your
                account or register:
            </p>

            <div
                className="highlight-feed__content__flex"
                data-preferences-container
            >
                <div
                    className="highlight-feed__content__flex-item sign-in"
                    data-form-container
                >
                    <spektrix-login data-spektrix-domain={spektrixDomain}>
                        <form className="login-form" action="">
                            <fieldset>
                                <h3>Sign into your account</h3>

                                <p>
                                    There&apos;s has been an error while logging
                                    in, please try again
                                </p>

                                <label htmlFor="spektrixLoginEmail">
                                    Email Address <span>(required)</span>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="8"
                                        height="12"
                                        viewBox="0 0 8 12"
                                        fill="none"
                                    >
                                        <path
                                            d="M5.13406 11.6321c-.24375.244-.53844.3659-.88406.3659-.34563 0-.64031-.1219-.88406-.3659C3.12198 11.3884 3 11.0937 3 10.748c0-.3456.12198-.6403.36594-.88402.24375-.24395.53843-.36593.88406-.36593.34562 0 .64031.12198.88406.36593.24396.24372.36594.53842.36594.88402 0 .3457-.12198.6404-.36594.8841ZM5.15625 8.18555h-1.8125c0-.72917.04687-1.27604.14063-1.64063.09374-.36458.41145-.79687.95312-1.29687.35417-.33334.68229-.65104.98437-.95313.30209-.30208.45313-.67187.45313-1.10937 0-.35417-.13021-.6875-.39062-1-.26042-.3125-.67188-.46875-1.23438-.46875-.54208 0-.95365.15625-1.23469.46875-.28104.3125-.47021.64583-.5675 1L.8125 2.49805c.22917-.66667.64125-1.25 1.23625-1.750003.595-.5 1.32875-.7500001 2.20125-.7500001.95833 0 1.77083.2708341 2.4375.8125001.66667.541663 1 1.312503 1 2.312503 0 .72916-.1875 1.29166-.5625 1.6875-.375.39583-.75.77083-1.125 1.125-.39583.39583-.63542.73437-.71875 1.01562-.08333.28125-.125.69271-.125 1.23438Z"
                                            fill="#000"
                                        ></path>
                                    </svg>
                                </label>

                                <input
                                    type="email"
                                    id="spektrixLoginEmail"
                                    name="spektrixLoginEmail"
                                    autoComplete="email"
                                    required
                                />

                                <label htmlFor="spektrixLoginPassword">
                                    Password <span>(required)</span>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="8"
                                        height="12"
                                        viewBox="0 0 8 12"
                                        fill="none"
                                    >
                                        <path
                                            d="M5.13406 11.6321c-.24375.244-.53844.3659-.88406.3659-.34563 0-.64031-.1219-.88406-.3659C3.12198 11.3884 3 11.0937 3 10.748c0-.3456.12198-.6403.36594-.88402.24375-.24395.53843-.36593.88406-.36593.34562 0 .64031.12198.88406.36593.24396.24372.36594.53842.36594.88402 0 .3457-.12198.6404-.36594.8841ZM5.15625 8.18555h-1.8125c0-.72917.04687-1.27604.14063-1.64063.09374-.36458.41145-.79687.95312-1.29687.35417-.33334.68229-.65104.98437-.95313.30209-.30208.45313-.67187.45313-1.10937 0-.35417-.13021-.6875-.39062-1-.26042-.3125-.67188-.46875-1.23438-.46875-.54208 0-.95365.15625-1.23469.46875-.28104.3125-.47021.64583-.5675 1L.8125 2.49805c.22917-.66667.64125-1.25 1.23625-1.750003.595-.5 1.32875-.7500001 2.20125-.7500001.95833 0 1.77083.2708341 2.4375.8125001.66667.541663 1 1.312503 1 2.312503 0 .72916-.1875 1.29166-.5625 1.6875-.375.39583-.75.77083-1.125 1.125-.39583.39583-.63542.73437-.71875 1.01562-.08333.28125-.125.69271-.125 1.23438Z"
                                            fill="#000"
                                        />
                                    </svg>
                                </label>
                                <input
                                    type="password"
                                    id="spektrixLoginPassword"
                                    name="spektrixLoginPassword"
                                    autoComplete="current-password"
                                    required
                                />

                                <p
                                    style={{ display: "none" }}
                                    className="login-form__forgot-password"
                                >
                                    Forgotten password?
                                    <button
                                        style={{ display: "none" }}
                                        type="button"
                                        className="login-form__forgot-password--link"
                                        reset-password="true"
                                    >
                                        Reset password
                                    </button>
                                </p>

                                <p
                                    style={{ display: "none" }}
                                    className="confirmation-message"
                                    role="alert"
                                />
                                <p
                                    style={{ display: "none" }}
                                    className="error-message"
                                    role="alert"
                                />

                                <button
                                    className="btn btn--icon btn--black"
                                    type="submit"
                                >
                                    Sign in
                                </button>
                            </fieldset>
                        </form>
                    </spektrix-login>
                </div>

                <div
                    className="highlight-feed__content__flex-item register"
                    data-register-container
                >
                    <h3>Not registered yet?</h3>
                    <p className="type-body-s">
                        Click below to register for a new account.
                    </p>
                    <a className="btn btn--icon white" href={createAccountUrl}>
                        Register now
                    </a>
                </div>
            </div>
        </>
    );
};

export default LoginOrRegister;
